import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, Text } from '@redlink/components/atoms';
import { DrawerIcon, Checkbox } from '@redlink/components/molecules';

export const PreviewTabItemSelectable = memo(
  ({ item, isSelected, onChange, defaultTab }) => {
    const { styles, colors } = useStyle();
    const isDefaultTab = defaultTab === item;
    return (
      <View style={styles.container}>
        <DrawerIcon name={item} color={colors.gray23} size={24} />
        <Text style={styles.text}>{item}</Text>
        <Space size={8} />
        <Checkbox
          value={isSelected}
          iconCheckedColor={isDefaultTab ? colors.blue1 : colors.green1}
          iconEmptyColor={colors.gray22}
          onChange={!isDefaultTab && onChange}
        />
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: colors.gray23,
    fontSize: 12,
    lineHeight: 24,
    fontWeight: '500',
  },
}));
